import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import useCommonModalStore from '@/store/common-modal-store';
import PaymentWithIdModal from '@/components/payment-with-id/paymentWithIdModal';

const PaymentInputShape = () => {
  const { setShow } = useCommonModalStore();
  const openPaymentWithIdModal = () => {
    setShow(true, {
      center: true,
      dialogPanelClassName: 'p-0 w-[85%] md:w-[380px]',
      Body: () => <PaymentWithIdModal />,
    })
  }
  return (
    <Container className="dash-border-custom w-full rounded-full px-5 py-3 bg-gray-50 dark:bg-grayDark-750 cursor-pointer"
    onClick={openPaymentWithIdModal}>
      <Text className="text-black dark:text-white text-md leading-7">
        {localization.EnterPaymentId}
      </Text>
    </Container>
  )
}

export default PaymentInputShape;